import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Typography } from '@/components/Typography';

interface MenuButtonContentProps {
  backgroundColor?: string;
  textColor?: string;
  open?: boolean;
  children?: ReactNode;
  isActive?: boolean;
  showNewTag?: boolean;
}

export function MenuButtonContent({
  backgroundColor = 'bg-black dark:bg-gray-100',
  textColor = 'text-primary',
  open,
  children,
  isActive = false,
  showNewTag = false,
}: MenuButtonContentProps) {
  return (
    <>
      <span className="block transition-colors w-full h-full px-2 lg:px-3 py-4 relative group overflow-hidden">
        {/* Background color */}
        <span
          className={classNames(
            'absolute inset-x-0 inset-y-2 transition-all rounded-2',
            backgroundColor,
            open || isActive
              ? 'opacity-10'
              : 'opacity-0 group-hover:opacity-10',
            isActive &&
              'translate-y-[calc(100%+0.4rem)] group-hover:translate-y-0',
          )}
        />

        {/* Item Label */}
        <span
          className={classNames(
            'text-heading-350 lg:text-heading-400',
            'relative flex gap-1 items-center justify-center',
            textColor,
          )}
        >
          {children}
        </span>
      </span>

      {/* New tag renders as a sibling to help with overflow-hidden needs */}
      {showNewTag && (
        <Typography
          name="tag-300"
          tag="span"
          className="bg-purple-500 text-paper rounded-full px-2 py-0 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[1rem] border-2 border-paper"
        >
          New
        </Typography>
      )}
    </>
  );
}
